export default "__VITE_ASSET__DdAK7AXQ__"